import Page from 'components/layout/Page';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import Faqs from '../shared/Faqs';
import { FaqProps } from '../shared/FaqsItem';
import { StyledFaqsWrapper } from './CompassComponent.styled';
import CompassFeatures from './sections/features/CompassFeatures';
import CompassHero from './sections/hero/CompassHero';

const CompassComponent: React.FC = () => {
  const { t } = useI18n('salary-compass');
  const { locale } = useRouter();

  const faqs: FaqProps[] = [
    {
      question: t('salary-compass.faqs.faq1.question'),
      active: true,
      answer: (
        <HtmlTrans
          ns={'salary-compass'}
          i18nKey="salary-compass.faqs.faq1.answer"
          components={{
            portalAccess: (
              <a href={`${getAppUrl(APP_URLS.portalV2Dashboard, locale)}`} />
            ),
            portalCreate: (
              <a
                href={`${getAppUrl(
                  APP_URLS.join,
                  locale
                )}?locale=${locale}&source=unete-brujula`}
                onClick={(e) =>
                  ServiceEventTracking.trackExternalLandingCtaClicked(
                    e,
                    `${getAppUrl(
                      APP_URLS.join,
                      locale
                    )}?locale=${locale}&source=unete-brujula`,
                    'unete-brujula'
                  )
                }
              />
            )
          }}
        />
      ),
      renderComponent: true
    },
    {
      question: t('salary-compass.faqs.faq2.question'),
      answer: t('salary-compass.faqs.faq2.answer')
    },
    {
      question: t('salary-compass.faqs.faq3.question'),
      answer: t('salary-compass.faqs.faq3.answer')
    },
    {
      question: t('salary-compass.faqs.faq4.question'),
      answer: t('salary-compass.faqs.faq4.answer')
    }
  ];
  return (
    <Page hasScrollTop>
      <div>
        <CompassHero />
        <CompassFeatures />
        <StyledFaqsWrapper>
          <Faqs faqs={faqs} title={t('salary-compass.faqs.title')} />
        </StyledFaqsWrapper>
      </div>
    </Page>
  );
};

export default CompassComponent;
